export default (context) => {
    context.overlay = true
    context.popup.growButton = true
    context.popup.value = true
    context.popup.text = `Это предварительная стоимость.`
    context.popup.moreText = `В зависимости от даты и времени показа стоимость может измениться.`
}